import React, { useState, useLayoutEffect } from 'react';
import i18next from 'i18next';
import noCommentPlaceholder from '../../assets/no-comments-02@3x.png';

import './NoCommentPlaceholder.css';

const NoCommentPlaceholder = () => {
  const [size, setSize] = useState([0]);

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  return (
    <div styleName="container">
      <img
        styleName="image"
        src={noCommentPlaceholder}
        alt="No comment placeholder"
      />
      {size >= 450 ? (
        <p styleName="text-web">
          {`${i18next.t('noCommentPlaceholderText1')} ${i18next.t(
            'noCommentPlaceholderText2'
          )}` || 'No comments'}
        </p>
      ) : (
        <>
          <p styleName="text-mobile-top">
            {i18next.t('noCommentPlaceholderText1') || 'No comments'}
            <span styleName="text-mobile-bottom">
              {i18next.t('noCommentPlaceholderText2')}
            </span>
          </p>
        </>
      )}
    </div>
  );
};

export default NoCommentPlaceholder;
